enum UserRoleEnum {
  ROLE_WORKER = 'ROLE_WORKER',
  ROLE_USER = 'ROLE_USER',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
}

const UserRoleObj: Record<UserRoleEnum, string> = {
  [UserRoleEnum.ROLE_WORKER]: 'Colaborador',
  [UserRoleEnum.ROLE_USER]: 'Usuário',
  [UserRoleEnum.ROLE_ADMIN]: 'Administrador',
  [UserRoleEnum.ROLE_SUPER_ADMIN]: 'Super Administrador',
};

export { UserRoleObj };

export default UserRoleEnum;
